import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { CompetitorSiteConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var CompetitorSiteLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(CompetitorSiteLayer, _CRUTransportLayer);

  function CompetitorSiteLayer() {
    _classCallCheck(this, CompetitorSiteLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorSiteLayer).call(this, CONSTANTS.API.ENDPOINTS.COMPETITOR_SITE));
  }

  _createClass(CompetitorSiteLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Activates or deactivates competitor sites
     * @param ids Competitors site IDs
     * @param state Sets active state to false or true
     */

  }, {
    key: "toggleActive",
    value: function toggleActive(ids, state) {
      var _this = this;

      var toggleActivePromise = api(CONSTANTS.API.ENDPOINTS.COMPETITOR_SITE_CHANGE_STATE).post({
        ids: ids,
        state: state
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        return Promise.reject(error);
      });
      return toggleActivePromise;
    }
  }]);

  return CompetitorSiteLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", CompetitorSiteConverter)], CompetitorSiteLayer.prototype, "converter", void 0);